import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function valueRequiredValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    return value === undefined || value === null ? { required: true } : null;
  };
}
